module.exports = __webpack_public_path__ + "kp.652ed8b34432cdbeb0a6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/kp.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/kp.svg
// module chunks = styles